<template>
  <v-dialog :value="true" persistent overlay-opacity="1" overlay-color="#1f51a4" width="600px">
    <v-card>
      <v-container class="login-logo">
        <v-row align="center" justify="center">
          <v-col cols="4" class="login-logo">
            <v-img src="@/assets/itmo_small_blue_logo.png"></v-img>
          </v-col>
          <v-col cols="8">
            <v-alert v-if="$store.getters.authStatus === 'error'" type="error" color="#ec1946">
              Неправильный логин или пароль
            </v-alert>
            <v-card-subtitle class="mb-n2 mt-2 white--text bold-text">Логин</v-card-subtitle>
            <v-text-field v-model="username" solo class="ml-4 mr-4"></v-text-field>
            <v-card-subtitle class="mb-n2 mt-n8 white--text bold-text">Пароль</v-card-subtitle>
            <v-text-field v-model="password" solo type="password" class="mt-n2 ml-4 mr-4"></v-text-field>
            <v-card-actions>
              <v-spacer>
              </v-spacer>
              <v-btn large color="#ec1946" class="mr-2" @click="login">
                <span class="white--text">
                  Войти
                </span>
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    async login () {
      const user = {
        username: this.username,
        password: this.password
      }
      await this.$store.dispatch({
        type: 'loginRequest',
        user: user
      })
      if (this.$store.getters.authStatus === 'ok') {
        await this.$router.push({
          name: 'Learn'
        })
      }
    }
  },
  created () {
    this.$store.commit({
      type: 'loginInitial'
    })
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/colors";
  .login-logo {
    background-color: $itmo-blue!important;
  }
  .bold-text {
    font-weight: bold!important;
  }
</style>
